export const CATEGORIES_KEYS = Object.freeze({
  purchasedGoodsAndServices: "purchasedGoodsAndServices",
  capitalGoods: "capitalGoods",
  fuelAndEnergyRelatedActivities: "fuelAndEnergyRelatedActivities",
  upstreamTransportationAndDistribution: "upstreamTransportationAndDistribution",
  wasteGeneratedInOperations: "wasteGeneratedInOperations",
  businessTravel: "businessTravel",
  employeeCommuting: "employeeCommuting",
  upstreamLeasedAssets: "upstreamLeasedAssets",
  downstreamTransportationAndDistribution: "downstreamTransportationAndDistribution",
  processingOfSoldProducts: "processingOfSoldProducts",
  useOfSoldProducts: "useOfSoldProducts",
  treatmentOfSoldProducts: "treatmentOfSoldProducts",
  downstreamLeasedAssets: "downstreamLeasedAssets",
  franchises: "franchises",
  investments: "investments"
});

// Maps a CATEGORIES_KEYS value (camelCase, used everywhere on the FE) to the backend
// ScopeCategoryKey enum name (UPPER_SNAKE_CASE) used by the manual-emissions API.
export const CATEGORY_KEY_TO_SCOPE_ENUM = Object.freeze({
  purchasedGoodsAndServices: "PURCHASED_GOODS_AND_SERVICES",
  capitalGoods: "CAPITAL_GOODS",
  fuelAndEnergyRelatedActivities: "FUEL_AND_ENERGY_RELATED_ACTIVITIES",
  upstreamTransportationAndDistribution: "UPSTREAM_TRANSPORTATION_AND_DISTRIBUTION",
  wasteGeneratedInOperations: "WASTE_GENERATED_IN_OPERATIONS",
  businessTravel: "BUSINESS_TRAVEL",
  employeeCommuting: "EMPLOYEE_COMMUTING",
  upstreamLeasedAssets: "UPSTREAM_LEASED_ASSETS",
  downstreamTransportationAndDistribution: "DOWNSTREAM_TRANSPORTATION_AND_DISTRIBUTION",
  processingOfSoldProducts: "PROCESSING_OF_SOLD_PRODUCTS",
  useOfSoldProducts: "USE_OF_SOLD_PRODUCTS",
  treatmentOfSoldProducts: "TREATMENT_OF_SOLD_PRODUCTS",
  downstreamLeasedAssets: "DOWNSTREAM_LEASED_ASSETS",
  franchises: "FRANCHISES",
  investments: "INVESTMENTS",
});

export const CATEGORIES_STEPS = [
  CATEGORIES_KEYS.purchasedGoodsAndServices,
  CATEGORIES_KEYS.capitalGoods,
  CATEGORIES_KEYS.fuelAndEnergyRelatedActivities,
  CATEGORIES_KEYS.upstreamTransportationAndDistribution,
  CATEGORIES_KEYS.wasteGeneratedInOperations,
  CATEGORIES_KEYS.businessTravel,
  CATEGORIES_KEYS.employeeCommuting,
  CATEGORIES_KEYS.upstreamLeasedAssets,
  CATEGORIES_KEYS.downstreamTransportationAndDistribution,
  CATEGORIES_KEYS.processingOfSoldProducts,
  CATEGORIES_KEYS.useOfSoldProducts,
  CATEGORIES_KEYS.treatmentOfSoldProducts,
  CATEGORIES_KEYS.downstreamLeasedAssets,
  CATEGORIES_KEYS.franchises,
  CATEGORIES_KEYS.investments
];
